import { StyleSheet } from 'aphrodite';
import { error } from '../../../../../web/styles/colors';
import { CssSelectors } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	count: {
		color: '#858585',
		display: 'flex',
		fontSize: 14,
		justifyContent: 'flex-start',
		padding: '16px 0',
		width: '100%',
	},
	countImportant: {
		color: error,
	},
	filter: {
		alignItems: 'center',
		color: '#858585',
		display: 'flex',
		fontSize: 14,
		justifyContent: 'flex-end',
		width: '100%',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	filterDropdown: { width: 200 },
	header: {
		display: 'flex',
		flexDirection: 'column',
		padding: 16,
		flex: 'none',
	},
	list: {
		flex: 1,
		overflowY: 'auto',
		minHeight: 0,
	},
	listItem: {
		background: '#E8F3F9',
		cursor: 'auto',
	},
	listItemLoading: {
		background: '#fff',
		boxSizing: 'border-box',
		padding: '10px 0',
	},
});
